var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.565 5.24-7.621 7.622c-2.346 2.345-3.518 4.69-.587 7.621s5.277 1.759 7.622-.586L22.29 7.585c1.759-1.758 1.173-3.517 0-4.69-1.172-1.172-2.931-1.759-4.69 0L5.29 15.207c-1.173 1.172-1.173 2.345-.587 2.931s1.76.586 2.932-.586l11.139-11.14"
  })));
});
const SvgAttachment = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAttachment);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjU2NDkgNS4yNDAyNEwyLjk0MzUxIDEyLjg2MTdDMC41OTg0NTEgMTUuMjA2NyAtMC41NzQwNzYgMTcuNTUxOCAyLjM1NzI0IDIwLjQ4MzFDNS4yODg1NiAyMy40MTQ0IDcuNjMzNjEgMjIuMjQxOSA5Ljk3ODY3IDE5Ljg5NjhDMTEuNzM3NSAxOC4xMzggMTkuOTQ1MiA5LjkzMDM1IDIyLjI5MDIgNy41ODUzQzI0LjA0OSA1LjgyNjUxIDIzLjQ2MjcgNC4wNjc3MSAyMi4yOTAyIDIuODk1MTlDMjEuMTE3NyAxLjcyMjY2IDE5LjM1ODkgMS4xMzY0IDE3LjYwMDEgMi44OTUxOUMxNS44NDEzIDQuNjUzOTggNi40NjEwOSAxNC4wMzQyIDUuMjg4NTYgMTUuMjA2N0M0LjExNjAzIDE2LjM3OTMgNC4xMTYwMyAxNy41NTE4IDQuNzAyMyAxOC4xMzhDNS4yODg1NiAxOC43MjQzIDYuNDYxMDkgMTguNzI0MyA3LjYzMzYyIDE3LjU1MThDOC41NzE2NCAxNi42MTM4IDE2LjAzNjcgOS4xNDg2NyAxOC43NzI2IDYuNDEyNzciIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";